<template>
  <div>
    <imDesk
      :show-drag-hint="true"
      @click="handleButton1Click"
      v-if="showDesk"
    />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth' // get token from cookie
import imDesk from '@/views/mobile/components/imDesk'

export default {
  name: 'DeskAll',
  components: { imDesk },
  data() {
    return {
      button1Theme: 'primary',
      button1Size: 'normal',
      clickCount: 0,
      lastPosition: null,
      themes: ['primary', 'secondary', 'success', 'warning', 'danger'],
      themeIndex: 0,
      sizes: ['small', 'normal', 'large'],
      sizeIndex: 1,
      showDesk: false
    }
  },
  mounted() {
    if (getToken()) {
      this.showDesk = true
    }
  },
  methods: {
    handleButton1Click(e) {
      this.$router.push({ path: '/mobile-desk' })
    },
    handleSuccessClick() {
    },
    handlePositionChange(data) {
      this.lastPosition = `X: ${data.position.x}, Y: ${data.position.y}, 边缘: ${data.edge}`
    },
    handleDragStart() {
    },
    handleDragEnd() {
    },
    toggleButton1() {
      const button = this.$refs.button1
      if (button.isHidden) {
        button.show()
      } else {
        button.hide()
      }
    },
    resetButton1() {
      this.$refs.button1.resetPosition()
      this.lastPosition = '已重置'
    },
    changeButton1Theme() {
      this.themeIndex = (this.themeIndex + 1) % this.themes.length
      this.button1Theme = this.themes[this.themeIndex]
      this.sizeIndex = (this.sizeIndex + 1) % this.sizes.length
      this.button1Size = this.sizes[this.sizeIndex]
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/mobile/components/deskAll.vue